﻿import * as React from "react";
import { Carousel, CarouselControl, CarouselIndicators, CarouselItem } from "reactstrap";
import { Record } from "immutable";
import { v4 as uuid } from 'uuid';

interface ImgCarouselProps {
	items: Array<{
		src: string,
		url: string
	}>;
}

const initialImgCarouselState = {
	activeIndex: 0
};

class ImgCarouselState extends Record(initialImgCarouselState) {
	public activeIndex: number;
}

/**
 * Img slider Carousel
 * Based on this example: https://reactstrap.github.io/components/carousel/
 */
export class HomeCarousel extends React.Component<ImgCarouselProps, ImgCarouselState> {

	private animating: boolean = false;
	private readonly slides: JSX.Element[];

	constructor(props: ImgCarouselProps) {
		super(props);
		this.state = new ImgCarouselState();
		this.next = this.next.bind(this);
		this.previous = this.previous.bind(this);
		this.goToIndex = this.goToIndex.bind(this);
		this.onExiting = this.onExiting.bind(this);
		this.onExited = this.onExited.bind(this);

		this.slides = this.props.items.map(item => {
			return (
				<CarouselItem
					onExiting={this.onExiting}
					onExited={this.onExited}
					onEnter={this.onExited}
					key={uuid()}
				>
					<a href={item.url}>
						<img src={item.src} />
					</a>
				</CarouselItem>
			);
		});
	}

	private onExiting(): void {
		this.animating = true;
	}

	private onExited(): void {
		this.animating = false;
	}

	private next(): void {
		if (this.animating) {
			return;
		}
		this.setState({ activeIndex: (this.state.activeIndex + 1) % this.props.items.length });
	}

	private previous(): void {
		if (this.animating) {
			return;
		}
		this.setState({ activeIndex: (this.state.activeIndex - 1 + this.props.items.length) % this.props.items.length });
	}

	private goToIndex(newIndex: number): void {
		if (this.animating || this.state.activeIndex === newIndex) {
			return;
		}
		this.setState({ activeIndex: newIndex });
	}

	render() {

		const { activeIndex } = this.state;
		return (
			<Carousel
				activeIndex={activeIndex}
				next={this.next}
				previous={this.previous}
			>
				<CarouselIndicators
					items={this.props.items}
					activeIndex={activeIndex}
					onClickHandler={this.goToIndex}
				/>
				{this.slides}
				<CarouselControl
					direction={"prev"}
					directionText={"Previous"}
					onClickHandler={this.previous}
				/>
				<CarouselControl
					direction={"next"}
					directionText={"Next"}
					onClickHandler={this.next}
				/>
			</Carousel>
		);
	}
}

export default HomeCarousel;